import type { Mission } from '../missions.ts'

export const usss: Mission = {
  id: "usss",
  name: "U.S. Secret Service",
  short: "USSS",
  call: "Secret Service",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.secretservice.gov/",
  established: 1865,
  palette: {
    primary: "#002d61",
    secondary: "#2f4668",
    accent: "#d5cca8",
  },
  colorSource: {
    kind: "site",
    url: "https://www.secretservice.gov/",
  },
  motif: "star",
  mission: {
    text: "We have an integrated mission of protection and investigations to ensure the safety and security of our protectees, key locations, and events of national significance.",
    url: "https://www.secretservice.gov/about/overview",
  },
  fact: {
    text: "The Secret Service was created in 1865 to stamp out counterfeiting, when nearly one-third of currency in circulation was counterfeit.",
    url: "https://www.secretservice.gov/about/history",
  },
  seal: {
    file: "public/seals/usss.png",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Secret_Service.svg",
  },
  identifier: {
    about: "https://www.secretservice.gov/about/overview",
    accessibility: "https://www.secretservice.gov/section508",
    foia: "https://www.secretservice.gov/foia/overview",
    noFear: "https://www.secretservice.gov/nofear",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.secretservice.gov/sites/default/files/reports/2025-07/2025-Strategic-Plan-FINAL.pdf",
    privacy: "https://www.secretservice.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/usss-rowley-center.jpg",
        small: "/media/usss-rowley-center-sm.jpg",
        alt: "The low entrance building of the James J. Rowley Training Center, with black SUVs parked out front and a group walking toward the doors.",
        title: "James J. Rowley Training Center, U.S. Secret Service, July 10, 2013",
        creator: "Shane T. McCoy, U.S. Marshals Service",
        source: "https://commons.wikimedia.org/wiki/File:Secret_Service_building_with_law_enforcement_explorers_in_foreground.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usss-motorcade.jpg",
        small: "/media/usss-motorcade-sm.jpg",
        alt: "A Secret Service motorcade of black vehicles travels down Pennsylvania Avenue toward the U.S. Capitol dome on a gray day.",
        title: "Secret Service motorcade on Pennsylvania Avenue, Inauguration Day, January 20, 2017",
        creator: "Cpl. Timothy Turner, U.S. Marine Corps",
        source: "https://commons.wikimedia.org/wiki/File:Presidential_motorcade_on_Inauguration_Day_01-20-17.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
